import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export default function DCardBody({ className, style, children, }) {
    return (_jsx("div", { className: classNames('card-body', className), style: style, children: children }));
}
//# sourceMappingURL=DCardBody.js.map